import styled from '@emotion/styled';

export const ItemsFooterWrapper = styled.footer`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    margin-top: 3rem;
    margin-bottom: 2rem;

    > * {
        align-self: center;
    }

    > :nth-of-type(3) {
        margin-left: auto;
    }

    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr 1fr;

        .a-page-indicator {
            display: none;
        }
        
        .a-button__label {
            max-width: 8rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
